
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";

export interface Breadcrumb {
  label: string;
  link?: string;
  icon?: string;
}

@Component({
    selector: "app-page-header",
    imports: [RouterModule],
    templateUrl: "./page-header.component.html",
    styleUrl: "./page-header.component.scss"
})
export class PageHeaderComponent {
  @Input() title!: string;
  @Input() titleIcon!: string;
  @Input() subtitle?: string;
  @Input() headerFlexWrap: boolean = true; // Variável pra informar se deve quebar o header ou não em dispositivos menores
  @Input() breadcrumbs?: Breadcrumb[];
}
